module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Laptop-macbook-b4103717f68a32df7e3a3d74bc641214.svg";